<app-alert-erro-customizado [alertErro]="alertError" [alertErroBotao]="'FECHAR'" [alertErroTitulo]="tituloMensagemErro" [alertErroMensagem]="mensagemErro" (alertErroFechou)="fecharAlertError($event)"></app-alert-erro-customizado>
<app-page-layout [alertLoading]="alertLoading" [alertSucesso]="alertSucesso">
  <h1 class="titulo">Filiais</h1>
  @if (formulario) {
    <form [formGroup]="formulario" class="col-12 mt-4 ps-0">
      <div class="row">
        <div class="col-12 col-lg-5 mb-4">
          <div class="mb-3">
            <label class="label-menor" for="inptCnpj">CNPJ</label>
            <input type="text" class="form-control" id="inptCnpj" formControlName="cnpj" mask="00.000.000/0000-00" [dropSpecialCharacters]="true" placeholder="Cnpj da empresa">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12 col-lg-6 col-xl-7 mb-4">
          <div class="mb-3">
            <label class="label-menor" for="inptRazaoSocial">RAZÃO SOCIAL</label>
            <input type="text" class="form-control" id="inptRazaoSocial" formControlName="nmSocial" placeholder="Razão social">
          </div>
          @if (formulario.value.nmSocial.length>80) {
            <p class="legenda-erro mb-0">Razão social pode ter até 80 caractéres</p>
          }
        </div>
        <div class="col-12 col-md-6 col-lg-6 col-xl-5 mb-4">
          <div class="mb-3">
            <label class="label-menor" for="inptNomeFantasia">NOME FANTASIA</label>
            <input type="text" class="form-control" id="inptNomeFantasia" formControlName="nmFantasia" placeholder="Nome fantasia">
          </div>
          @if (formulario.value.nmFantasia.length>30) {
            <p class="legenda-erro mb-0">Nome fantasia pode ter até 30 caractéres</p>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12 col-lg-4 col-xl-7">
          <div class="mb-4">
            <label class="label-menor" for="slctRamoAtividade">RAMO DE ATIVIDADE</label>
            <app-select
              [form]="formulario"
              name="rmAtividade"
              id="slctRamoAtividade"
              [options]="ramosAtividadeApi"
              optionValue="idRamoAtividade"
              defaultDescription="Selecionar Ramo de Atividade"
              optionText="descricao">
            </app-select>
            @if (ramosAtividadeApi === false) {
              <div><p class="legenda-erro">Erro ao consultar ramos de atividade</p></div>
            }
            @if (ramosAtividadeApi === null) {
              <div>
                <div class="text-center">
                  <output>
                    <div class="spinner-border c-primary">
                      <span class="visually-hidden">Consultando ramos de atividade ...</span>
                    </div>
                  </output>
                </div>
                <p class="legenda-spinner">Consultando ramos de atividade ...</p>
              </div>
            }
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl">
          <div class="mb-4">
            <label class="label-menor text-nowrap" for="inptInscricaoEstadual">INSCRIÇÃO ESTADUAL</label>
            <input type="text" class="form-control" id="inptInscricaoEstadual" formControlName="insEstadual" placeholder="Exemplo: 123456">
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl">
          <div class="mb-4">
            <label class="label-menor text-nowrap" for="inptInscricaoMunicipal">INSCRIÇÃO MUNICIPAL</label>
            <input type="text" class="form-control" id="inptInscricaoMunicipal" formControlName="insMunicipal" placeholder="Exemplo: 123456">
          </div>
        </div>
      </div>
    </form>
  }

  <div class="w-100 d-flex mt-3">
    <button class="botao-outline me-auto" id="btnFechar" (click)="voltarAbaFilial()">CANCELAR</button>
    <button class="botao me-auto" id="btnSalvar" (click)="adicionarFilial()" [ngClass]="{ 'disabled': !formulario.valid }" [disabled]="!formulario.valid" data-bs-toggle="tooltip" data-placement="top" title="Preencha todos os campos obrigatórios.">SALVAR</button>
  </div>
</app-page-layout>
